import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-465ecadc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Check your email", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Please enter the 6 digit code "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("sent to your email.")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "flex-desktop buttons-container"
}
const _hoisted_5 = { class: "container" }

import { personAdd, mailOpen } from "ionicons/icons";

import {
  IonPage,
  IonItem,
  IonFooter,
  IonContent,
  IonInput,
  IonButton,
  IonLoading,
  IonNote,
  IonIcon,
  IonTitle,
  IonButtons,
  IonHeader,
  IonToolbar,
  IonBackButton,
  useIonRouter,
} from "@ionic/vue";
import { reactive } from "vue";
import { useUserStore } from "@/stores/user";
import { confirmEmail } from "@/api/auth";
import { useForm } from "@/views";
import { useToasters } from "@/composition/toasters";
import { addUser } from "@/api/users";
import { useWindowWidth } from "@/composition/window";


export default /*#__PURE__*/_defineComponent({
  __name: 'VerifyEmail',
  setup(__props) {

const { isMobile } = useWindowWidth();

const router = useIonRouter();

const userStore = useUserStore();

const form = useForm();

const toasters = useToasters();

const state = reactive({
  loading: false,
  prevkey: "",
  confirmkey: "",
  wrong_key: false,
});

const validateCode = () => {
  state.wrong_key = false;
  if (/[a-zA-Z]/.test(state.confirmkey)) {
    state.confirmkey = state.prevkey;
  } else {
    state.prevkey = state.confirmkey;
  }
};

const validateEmail = () => {
  state.loading = true;

  confirmEmail({
    email: form.user.email,
    confirmkey: state.confirmkey,
  })
    .then(() => {
      userStore
        .login({
          username: form.user.email,
          password: form.user.password,
        })
        .then(() => {
          userStore.fetchMe().then(() => {
            userStore.fetchRoles().then(() => {
              state.loading = false;
              router.push("/onboarding/welcome");
            });
          });
        })
        .catch(() => {
          state.loading = false;
        });
    })
    .catch(() => {
      state.loading = false;
      state.wrong_key = true;
    });
};

const resendKey = () => {
  state.loading = true;

  addUser(form.user)
    .then(() => {
      state.loading = false;
      toasters.addSuccess("Please check your inbox");
    })
    .catch(() => {
      toasters.addError("Error sending email, please try again");
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonBackButton), {
                    color: "white",
                    "default-href": "/onboarding/introduction"
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Email verification")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("section", null, [
              _hoisted_2,
              _hoisted_3,
              _createVNode(_unref(IonItem), {
                class: _normalizeClass(["ion-text-center", { 'ion-invalid': state.wrong_key }]),
                style: {"margin":"20px"},
                fill: "outline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonInput), {
                    type: "text",
                    modelValue: state.confirmkey,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.confirmkey) = $event)),
                    maxlength: 6,
                    onInput: _cache[1] || (_cache[1] = ($event: any) => (validateCode()))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_unref(IonNote), { slot: "error" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" This key is invalid ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_unref(IonIcon), {
                icon: _unref(mailOpen),
                color: "light",
                style: {"margin":"0 auto","font-size":"6rem","display":"block"}
              }, null, 8, ["icon"]),
              (!_unref(isMobile))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_unref(IonButton), {
                      expand: "block",
                      fill: "clear",
                      class: "ion-margin-bottom",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (resendKey()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Resend code ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonButton), {
                      expand: "block",
                      color: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (validateEmail()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), {
                          slot: "start",
                          icon: _unref(personAdd)
                        }, null, 8, ["icon"]),
                        _createTextVNode(" Continue ")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }),
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(_unref(IonFooter), { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("section", null, [
                  _createVNode(_unref(IonButton), {
                    expand: "block",
                    fill: "clear",
                    class: "ion-margin-bottom",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (resendKey()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Resend code ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonButton), {
                    expand: "block",
                    color: "primary",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (validateEmail()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "start",
                        icon: _unref(personAdd)
                      }, null, 8, ["icon"]),
                      _createTextVNode(" Continue ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonLoading), {
        "is-open": state.loading,
        message: "Please wait..."
      }, null, 8, ["is-open"])
    ]),
    _: 1
  }))
}
}

})